module.exports = __webpack_public_path__ + "static/media/thumbnail-acelszerkezet_bontas.fff158d2.jpg";